@use '../../sass/theme';

$variants: primary, secondary, success, info, warning, danger, low, high;

@mixin get-variants() {
  @each $variant in $variants {
    .qrcode--#{$variant} {
      --jui-qrcode-color-bg: var(--jui-#{$variant}-color);
      --jui-qrcode-color-darker-bg: var(--jui-#{$variant}-color--darker);
      --jui-qrcode-color-darkest-bg: var(--jui-#{$variant}-color--darkest);
      --jui-qrcode-color-contrast-bg: var(--jui-#{$variant}-color--contrast);
    }
  }
}

:host {
  display: block;
  contain: content;


  // todo this should be refactored to BEM

  .qr-container {
    position: relative;
  }

  .image-container {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .image-wrapper {
      width: 10%;
      background-color: var(--jui-qrcode-color-contrast);
      filter: contrast(0.6);

      & ::slotted(img[slot='image']) {
        width: 100% !important;
      }
    }
  }

  svg {
    .module {
      fill: var(--jui-qrcode-color-bg);
    }

    .position-center {
      fill: var(--jui-qrcode-color-darker-bg);
    }

    .position-ring {
      fill: var(--jui-qrcode-color-darkest-bg);
    }
  }
  @include get-variants();
}

